module.exports = __webpack_public_path__ + "img/fan.c8c345a5.svg";